export const API_URL: string = import.meta.env.REACT_APP_API_URL ?? 'https://localhost'
